import { z } from "zod";

/// Lenient on purpose: the backend may add fields, and a stricter schema would drop the card
/// for every conversation that carries them.
const readPartSchema = z.object({
  toolCallId: z.string(),
  capability: z.string(),
  data: z.unknown(),
  truncated: z.record(z.string(), z.number()).optional(),
});

export interface CopilotReadCardData {
  capability: string;
  data: unknown;
  /** Original length of each top-level list the server cut, so a card never claims an exact count. */
  truncated?: Record<string, number>;
}

/// The data the backend sent for one read, found in the message's `copilot-read` data parts.
export function readCopilotCardData(
  parts: readonly { type: string; name?: string; data?: unknown }[],
  toolCallId: string,
): CopilotReadCardData | null {
  for (const part of parts) {
    if (part.type !== "data" || part.name !== "copilot-read") continue;
    const parsed = readPartSchema.safeParse(part.data);
    if (!parsed.success || parsed.data.toolCallId !== toolCallId) continue;
    const { capability, data, truncated } = parsed.data;
    return { capability, data, ...(truncated ? { truncated } : {}) };
  }
  return null;
}
